var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1071_22628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H22.5V21.75C22.5 21.15 22.26 20.58 21.84 20.16C21.42 19.74 20.85 19.5 20.25 19.5H17.25C16.65 19.5 16.08 19.74 15.66 20.16C15.24 20.58 15 21.15 15 21.75V24H13.5V21.75C13.5 20.76 13.9 19.8 14.6 19.1C15.3 18.4 16.26 18 17.25 18H20.25C21.24 18 22.2 18.4 22.9 19.1C23.6 19.8 24 20.76 24 21.75V24Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.5C19.19 10.5 19.63 10.63 20 10.88C20.37 11.13 20.66 11.48 20.83 11.89C21 12.3 21.04 12.75 20.96 13.19C20.87 13.63 20.66 14.03 20.34 14.34C20.03 14.65 19.62 14.87 19.19 14.96C18.75 15.05 18.3 15 17.89 14.83C17.48 14.66 17.13 14.37 16.88 14C16.63 13.63 16.5 13.19 16.5 12.75C16.5 12.15 16.74 11.58 17.16 11.16C17.58 10.74 18.15 10.5 18.75 10.5ZM18.75 9C18.01 9 17.28 9.22 16.67 9.63C16.05 10.04 15.57 10.63 15.29 11.31C15.01 12 14.93 12.75 15.08 13.48C15.22 14.21 15.58 14.88 16.11 15.4C16.63 15.92 17.3 16.28 18.03 16.43C18.76 16.57 19.51 16.5 20.2 16.22C20.89 15.94 21.47 15.46 21.88 14.84C22.29 14.22 22.51 13.5 22.51 12.76C22.51 11.77 22.11 10.81 21.41 10.11C20.71 9.41 19.75 9.01 18.76 9.01L18.75 9Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H9.75C9.52 1.5 9.37 1.57 9.22 1.72L3.97 6.97C3.82 7.12 3.75 7.27 3.75 7.5V21C3.75 21.82 4.42 22.5 5.25 22.5H12V21H5.25V9H9.75C10.57 9 11.25 8.32 11.25 7.5V3H18.75V7.5H20.25V3C20.25 2.17 19.58 1.5 18.75 1.5ZM9.75 7.5H5.55L9.75 3.3V7.5Z",
    fill: "#030712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1071_22628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserDocument);
export default __webpack_public_path__ + "static/media/ic-user-document.8ace5dfb81b7d51dd1776aea4571f8a6.svg";
export { ForwardRef as ReactComponent };